/**
 * MODULE: domain/sales-intelligence/frontend/components/MessageBubble.tsx
 * PURPOSE: Chat message bubble component for displaying user and assistant messages
 * 
 * DEPENDENCIES:
 *   - react: React library
 * 
 * PUBLIC API:
 *   - MessageBubble: Message display component
 * 
 * SIDE EFFECTS:
 *   - None (presentational only)
 * 
 * AGENT SAFETY: SAFE
 * FILE SIZE: 49 / 200 lines
 * 
 * See: /README.md#documentation | /ARCHITECTURE.md | /domain/sales-intelligence/README.md
 */

import React from 'react';

interface MessageBubbleProps {
  message: {
    role: 'user' | 'assistant' | 'system';
    content: string;
    timestamp: Date;
  };
}

export function MessageBubble({ message }: MessageBubbleProps) {
  const isUser = message.role === 'user';

  return (
    <div className={`flex ${isUser ? 'justify-end' : 'justify-start'}`}>
      <div
        className={`max-w-[70%] px-4 py-2 rounded-lg ${
          isUser
            ? 'bg-blue-600 text-white'
            : 'bg-white text-gray-900 border border-gray-200'
        }`}
      >
        <p className="text-sm whitespace-pre-wrap">{message.content}</p>
        <p className={`text-xs mt-1 ${isUser ? 'text-blue-100' : 'text-gray-500'}`}>
          {message.timestamp.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
        </p>
      </div>
    </div>
  );
}
